export default __webpack_public_path__ + "static/media/sz.e82d0717.jpg";